import React from 'react';
import { AuthConsumer } from './AuthProvider';

// NOTE: This should be deprecated in favor of the useAuth hook
const withAuth = Component => props => (
  <AuthConsumer>
    {({
      isAuth, setToken, getToken, removeToken, setUserToLocalStorage, setUserGmailToLocalStorage,
    }) => <Component {...props} {...{ isAuth, setToken, getToken, removeToken, setUserToLocalStorage, setUserGmailToLocalStorage }} />}
  </AuthConsumer>
);

export default withAuth;
